/* Used for swapping product variants on product cards */
/* This function is also called in facets.js for when ajax is complete after a filter is selected on a collection page */
function initializeProductScripts() {
    var styleGroups = document.querySelectorAll('.style-group');

    styleGroups.forEach(function(styleGroup) {
      var mainProductImage = styleGroup.querySelector('.main-image');
      var productPriceElement = styleGroup.querySelector('.product-price');
      var productTitle = styleGroup.querySelector('.product-title');
      var productSubtitle = styleGroup.querySelector('.product-subtitle');
      var mainImageLink = styleGroup.querySelector('.main-image-link');
      var productCardCTA = styleGroup.querySelector('.product-card--cta');
      var relatedProducts = styleGroup.querySelectorAll('.related-product');
      var productTagsContainer = styleGroup.querySelector('.product__tags'); // Select the tags container

      relatedProducts.forEach(function(relatedProduct) {
        var mainImageSrc = relatedProduct.getAttribute('data-main-image');
        var mainTitle = relatedProduct.getAttribute('data-main-title');
        var mainSubtitle = relatedProduct.getAttribute('data-main-subtitle');
        var mainUrl = relatedProduct.getAttribute('data-main-url');
        var mainPriceCurrent = relatedProduct.getAttribute('data-main-price-current');
        var mainPriceCompare = relatedProduct.getAttribute('data-main-price-compare');
        var mainTags = relatedProduct.getAttribute('data-main-tags'); // Get the tags from data-main-tags


        relatedProduct.addEventListener('click', function() {
          mainProductImage.src = mainImageSrc;
          productTitle.textContent = mainTitle;
          productSubtitle.textContent = mainSubtitle;

          // Clear existing badges
          productTagsContainer.innerHTML = '';

          // Split the tags and create new badges
          if (mainTags) {
            var tagsArray = mainTags.split(',');
            tagsArray.forEach(function(tag) {
              var badge = document.createElement('div');
              badge.className = 'product__tags__badge color-promo-tag';
              badge.innerHTML = `<span>${tag.trim()}</span>`;
              productTagsContainer.appendChild(badge);
            });
          }

          // Update the price container with formatted price
          if (mainPriceCompare) {
            productPriceElement.innerHTML =
              '<span class="product-price--current sale">' + mainPriceCurrent + '</span>' +
              '<span class="product-price--compare sale">' + mainPriceCompare + '</span>';
          } else {
            productPriceElement.innerHTML =
              '<span class="product-price--current">' + mainPriceCurrent + '</span>';
          }

          // Update the link to the product page
          mainImageLink.href = mainUrl;
          productCardCTA.href= mainUrl;
        });
      });

      mainProductImage.addEventListener('click', function() {
        window.location.href = mainImageLink.href;
      });
    });
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductScripts();
});
